
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Properties from "./pages/Properties";
import AddProperty from "./pages/AddProperty";
import EditProperty from "./pages/EditProperty";
import PropertySettings from "./pages/PropertySettings";
import Settings from "./pages/Settings";
import AppSettings from "./pages/AppSettings";
import NotFound from "./pages/NotFound";
import Analytics from "./pages/Analytics";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import PaceReport from "./pages/reports/rmspace";
import React from 'react';
import { OAuth2Callback } from "./pages/callbacks";

const App = () => {
  // Create a client inside the component
  const queryClient = new QueryClient();
  
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <AuthProvider>
                <Routes>
                  {/* Public routes */}
                  <Route path="/login" element={<Login />} />
                  
                  {/* Callback routes - these are public and not behind the protected route */}
                  <Route path="/callbacks/OAuth2" element={<OAuth2Callback />} />
                  
                  {/* Protected routes */}
                  <Route element={<ProtectedRoute />}>
                    <Route element={<Layout><Outlet /></Layout>}>
                      <Route path="/" element={<Dashboard />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/reports" element={<Reports />} />
                      <Route path="/reports/rmspace" element={<PaceReport />} />
                      <Route path="/properties" element={<Properties />} />
                      <Route path="/properties/add" element={<AddProperty />} />
                      <Route path="/properties/:id/edit" element={<EditProperty />} />
                      <Route path="/properties/:id/settings" element={<PropertySettings />} />
                      <Route path="/settings" element={<Settings />} />
                      <Route path="/app-settings" element={<AppSettings />} />
                      <Route path="/dashboard/analytics/:dashboardId" element={<Analytics />} />
                      
                      {/* Nested routes */}
                    </Route>
                  </Route>
                  
                  {/* Not found route */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </AuthProvider>
            </BrowserRouter>
          </TooltipProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

export default App;
